<template>
    <v-container fluid class="pa-4">
        <div class="page-header mb-4">
            <div class="header-title">
                <v-icon color="primary" size="22">mdi-contacts-outline</v-icon>
                <div class="titles">
                    <h1>Rubrica clienti</h1>
                    <p class="subtitle">Visualizza, modifica ed esporta la rubrica aziendale</p>
                </div>
            </div>
            <v-col cols="12" md="6" class="text-right ma-0 pa-0">
                <template v-if="role === 1 || role === 3">
                    <v-btn color="grey-darken-2" variant="outlined" class="mr-2" size="small" @click="esportaExcel">
                        <v-icon left>mdi-export</v-icon> Esporta Excel
                    </v-btn>
                    <v-btn color="grey-darken-2" variant="outlined" class="mr-4" size="small"
                        @click="$refs.fileInput.click()">
                        <v-icon left>mdi-import</v-icon> Importa Excel
                        <v-tooltip activator="parent" location="bottom">
                            Importa i clienti compilando lo stesso template generato dall'Esportazione.
                        </v-tooltip>
                    </v-btn>
                    <input type="file" ref="fileInput" class="d-none" accept=".xlsx" @change="importaExcel" />
                </template>

                <v-btn color="primary" @click="$refs.dialogCliente.apri()">
                    <v-icon left>mdi-plus</v-icon> Nuovo Cliente
                </v-btn>
            </v-col>
        </div>

        <v-card variant="outlined" class="bg-white">
            <v-card-title>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Cerca Cliente..." single-line
                    hide-details variant="underlined"></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="clienti" :search="search" :loading="loading" class="elevation-0"
                dense>
                <template v-slot:[`item.azioni`]="{ item }">
                    <v-icon color="info" size="small" class="mr-3" @click="$refs.dialogCliente.apri(item)"
                        title="Modifica">mdi-pencil</v-icon>
                    <v-icon color="secondary" size="small" class="mr-3" @click="duplica(item)"
                        title="Duplica (Crea nuovo pre-compilato)">mdi-content-copy</v-icon>
                    <v-icon color="error" size="small" @click="chiediElimina(item)" title="Elimina">mdi-delete</v-icon>
                </template>
            </v-data-table>
        </v-card>

        <DialogCliente ref="dialogCliente" @salvato="caricaDati" />
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { getClienti, eliminaCliente, esportaClienti, importaClienti } from "@/api/api.clienti.js";
import DialogCliente from "@/components/clienti/DialogCliente.vue";

export default {
    components: { DialogCliente },
    data() {
        return {
            search: "",
            loading: false,
            clienti: [],
            headers: [
                { title: "Ragione Sociale", key: "ragioneSociale" },
                { title: "Referente", key: "cognome", value: v => `${v.cognome || ''} ${v.nome || ''}`.trim() },
                { title: "P.IVA / CF", key: "pIva", value: v => v.pIva || v.codiceFiscale },
                { title: "Città", key: "localita" },
                { title: "Telefono", key: "telefono" },
                { title: "Email", key: "email" },
                { title: "Azioni", key: "azioni", sortable: false, align: "end" }
            ]
        };
    },
    created() {
        this.caricaDati();
    },
    methods: {
        async caricaDati() {
            this.loading = true;
            try {
                const res = await getClienti();
                this.clienti = res.data;
            } finally {
                this.loading = false;
            }
        },
        duplica(item) {
            // Clona l'oggetto ma azzera l'ID così viene gestito come Inserimento Nuovo
            const copia = { ...item, clienteID: 0 };
            this.$refs.dialogCliente.apri(copia);
        },
        async chiediElimina(item) {
            if (confirm(`Sei sicuro di voler eliminare l'anagrafica di ${item.ragioneSociale || item.cognome}?`)) {
                try {
                    await eliminaCliente(item.clienteID);
                    this.$store.commit("app/showMessage", { testo: "Cliente eliminato", tipo: "success" });
                    this.caricaDati();
                } catch (e) {
                    console.error(e);
                }
            }
        },
        async esportaExcel() {
            try {
                const response = await esportaClienti();
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'RubricaClienti.xlsx');
                document.body.appendChild(link);
                link.click();
            } catch (e) {
                this.$store.commit("app/showMessage", { testo: "Errore esportazione", tipo: "error" });
            }
        },
        async importaExcel(event) {
            const file = event.target.files[0];
            if (!file) return;
            const formData = new FormData();
            formData.append("file", file);
            try {
                this.loading = true;
                const res = await importaClienti(formData);
                this.$store.commit("app/showMessage", { testo: res.data.messaggio, tipo: "success" });
                this.caricaDati();
            } catch (e) {
                console.error(e)
            } finally {
                event.target.value = "";
            }
        }
    },
    computed: {
        ...mapGetters('user', {
            role: 'getRole'
        })
    },
};
</script>